import React, { useEffect, useState } from 'react';
import { Building2, Loader2, Save } from 'lucide-react';
import { stockApi } from '../api';

export default function StockConfigCard({ theme }) {
  const [code, setCode] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState({ ok: true, text: '' });
  useEffect(() => { stockApi.config().then(c => setCode(c.hoBranchCode || '')).catch(() => {}); }, []);

  const save = async () => {
    setSaving(true); setMsg({ ok: true, text: '' });
    try { const r = await stockApi.saveConfig(code); setCode(r.hoBranchCode); setMsg({ ok: true, text: 'Head Office location saved' }); }
    catch (e) { setMsg({ ok: false, text: e.response?.data?.detail || 'Save failed' }); }
    finally { setSaving(false); }
  };

  return (
    <div className="fm-card p-4 mb-4 flex flex-wrap items-end gap-3" data-testid="stock-config-card">
      <div className="flex-1 min-w-[260px]">
        <div className="flex items-center gap-2 text-[13.5px] font-medium"><Building2 size={15} /> Head Office stock location</div>
        <p className="text-[12px] text-[#7a6f5c] mt-0.5">Branch code used for HO rows in stock files. Every Tester order also needs enough stock here.</p>
      </div>
      <input value={code} onChange={e => setCode(e.target.value)} data-testid="stock-ho-code-input" className="fm-focus border border-[#E7E2D3] rounded-md px-3 py-2 text-[13px] font-mono w-[160px]" />
      <button onClick={save} disabled={saving} data-testid="stock-ho-save-btn" className="inline-flex items-center gap-2 px-3 py-2 rounded-md text-white text-[13px] font-medium disabled:opacity-50" style={{ background: theme.primary }}>
        {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save
      </button>
      {msg.text && <div data-testid="stock-ho-msg" className={`w-full text-[12.5px] ${msg.ok ? 'text-[#2f6b41]' : 'text-[#9b2c1f]'}`}>{msg.text}</div>}
    </div>
  );
}
